import { z } from 'zod'

const avatarValueSchema = z.union([z.string(), z.instanceof(File), z.null()]);

export const imagesSchema = z.object({
    avatarUrl: avatarValueSchema,
    images: z
        .array(z.union([
            z.string(), // URL строка
            z.object({ url: z.string(), file: z.instanceof(File).optional() }) // Объект с url и опциональным file
        ]))
        .max(10, { message: "Максимум 10 изображений" })
        .refine((images) => {
            return images.every((img) => {
                if (typeof img === 'object' && 'file' in img && img.file && img.file instanceof File) {
                    return img.file.size <= 5 * 1024 * 1024; // 5 MB
                }
                return true; // Строки URL или объекты без file не проверяем
            });
        }, { message: "Размер каждого файла не должен превышать 5 МБ" }),
});